import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { MediaBlockService } from '../../services/media-block-service';
import { TimerPipe } from '@kinomap-dev/ng-ui-lib/core';

@Component({
  selector: 'app-syncro-editor-time-bar',
  imports: [TimerPipe],
  template: `
    <div class="time">
    @if(timers().length === 0){
      <span>0</span>
    } @else {
      @for(time of timers(); track $index; let last = $last){
        <span>{{time |timer:duration()}}</span>
        @if(!last){
          @for(point of [].constructor(3); track $index){
            <span>・</span>
          }
        }
      }
    }
  </div>`,
  styleUrl: './syncro-editor-time-bar.scss',
})
export class SyncroEditorTimeBar {
  mediaBlockService: MediaBlockService = inject(MediaBlockService);
  duration: InputSignal<number | undefined> = input.required<number | undefined>();
  timers: Signal<number[]> = computed(() => {
    const duration = this.duration();
    if (!duration) return [];
    const segmentCount = 6;
    const segmentDuration = duration / segmentCount;
    const timers: number[] = [];
    for (let i = 0; i <= segmentCount; i++) {
      timers.push(segmentDuration * i);
    }
    return timers;
  });
}
